import {
  GET_CAR_MAKE_SUCCESS,
  SHOW_CAR_MAKE_MODAL,
  HIDE_CAR_MAKE_MODAL,
  FETCH_MAKES_SUCCESS,
  CLEAN_MAKE_STORE,
} from '../actionTypes/make';

import { LOAD_CLIENT_BY_PLATE } from '../actionTypes/budgets';

const INITIAL_STATE = {
  currentMake: false,
  showCarMakeModal: false,
  makes: false, // false means not fetched
}

export default function (state = INITIAL_STATE, action) {
  let cleaned = {};
  switch (action.type) {
    case GET_CAR_MAKE_SUCCESS:
      return {
        ...state,
        currentMake: action.payload.currentMake,
      };
    case SHOW_CAR_MAKE_MODAL:
      return {
        ...state,
        showCarMakeModal: true,
      };
    case HIDE_CAR_MAKE_MODAL:
      return {
        ...state,
        showCarMakeModal: false,
      }
    case FETCH_MAKES_SUCCESS:
      return {
        ...state,
        makes: action.payload.makes,
      }
    case CLEAN_MAKE_STORE:
      if (action.payload.props === '*') {
        cleaned = INITIAL_STATE;
      } else if (Array.isArray(action.payload.props)) {
        action.payload.props.map((e) => {
          cleaned[e] = INITIAL_STATE[e];
        })
      }
      return {
        ...state,
        ...cleaned,
      }
    case LOAD_CLIENT_BY_PLATE:
      return {
        ...state,
        currentMake: action.payload.currentMake,
      }
    default:
      return {
        ...state,
      };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/makeReducer.js